import { render, staticRenderFns } from "./LayTop.vue?vue&type=template&id=33d16ea6&scoped=true&"
import script from "./LayTop.vue?vue&type=script&lang=js&"
export * from "./LayTop.vue?vue&type=script&lang=js&"
import style0 from "./LayTop.vue?vue&type=style&index=0&id=33d16ea6&lang=less&scoped=true&"
import style1 from "./LayTop.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d16ea6",
  null
  
)

export default component.exports